import { MESSAGES_AFTER_QUERY, SET_COMPLETED_QUERY, SET_IMPACT_MUTATION } from "@/constants/graphql/coach/coaching";
import { SECONDARY_COACHING_SUBSCRIPTION_QUERY, COACHING_DASHBOARD_LISTING_QUERY } from "@/graphql/queries/coaching";

import { getUserName } from "@/lib/username";
import TableHeader from "@/components/dashboard/components/TableHeader";
import ProfilePic from "@/components/dashboard/components/columns/ProfilePic";
import ClientName from "@/components/dashboard/components/columns/ClientName";
import Comms from "@/components/dashboard/components/columns/Comms";
import StickyNote from "@/components/dashboard/components/columns/StickyNote";
import ToolButtons from "@/components/dashboard/components/columns/ToolButtons";
import ActiveWorkoutBlocks from "@/components/dashboard/components/columns/ActiveWorkoutBlocks";
import Calendar from "@/components/dashboard/components/columns/Calendar";
import ExerciseLogged from "@/components/dashboard/components/columns/ExerciseLogged";
import ClientWeekDots from "@/components/client/blocks/progress/ClientWeekDots";
import EngagementScoreCircle from "@/components/shared/EngagementScoreCircle";
import LastMessageColumn from "@/components/dashboard/components/columns/LastMessage";
import ResolveMessageBtn from "@/components/dashboard/components/columns/ResolveMessage";
import { decodeId } from "@/lib/string";
import VueJsonToCsv from "vue-json-to-csv";

export default {
  components: {
    TableHeader,
    ProfilePic,
    ClientName,
    Comms,
    ToolButtons,
    ActiveWorkoutBlocks,
    Calendar,
    ExerciseLogged,
    ClientWeekDots,
    EngagementScoreCircle,
    LastMessageColumn,
    ResolveMessageBtn,
    VueJsonToCsv,
    StickyNote,
  },
  props: {
    lastUpdated: {
      type: [String, Object],
      required: false,
    },
  },
  data() {
    return {
      skipDashboardListingQuery: false,
      notesKey: 0,
      clients: [],
      stages: ["in_progress", "offboarding"],
      productType: "one-on-one",
      encodedCoachId: null,
      secondaryCoachId: null,
      productProgramType: null,
      selectedDate: this.$moment().format("YYYY-MM-DD"),
      loading: true,
      selectedProgram: null,
      selectedTicket: null,
      problemConnecting: false,
      timeout: null,
      hideResolved: false,
      hideCompleted: {
        selection: [],
        selectionCheckbox: false,
        selectionText: null,
        options: [
          {
            id: 1,
            name: "Hide rows",
            children: [
              { id: 2, name: "Hide AM" },
              { id: 3, name: "Hide PM" },
            ],
          },
        ],
      },
      chatsToMonitor: [],
      newMessagesFrom: [],
    };
  },
  watch: {
    lastUpdated() {
      this.reloadData();
    },
  },
  computed: {
    CSVData() {
      const data = [];
      this.subscriptions.forEach((element) => {
        const obj = JSON.parse(JSON.stringify(element));
        data.push({
          id: obj.userId,
          firstName: obj.client.firstName,
          lastName: obj.client.lastName,
          email: obj.username,
          birthday: obj.dateOfBirth,
          lastCoachingAssessmentDate: obj.lastCoachingAssessmentDate,
          lastUserAssessmentDate: obj.lastUserAssessmentDate,
          weeksOnProgram: obj.weeksOnProgram,
          signUpDate: obj.signUpDate,
          subscriptionEndDate: obj.subscriptionEndDate,
          nextSubscription: obj.nextSubscription,
        });
      });
      return data;
    },
  },
  methods: {
    onMessageViewed(message) {
      let sender = message.user.firstName + " " + message.user.lastName;
      let index = this.newMessagesFrom.findIndex((element) => element === sender);
      if (index > -1) this.newMessagesFrom.splice(index, 1);
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (!isNaN(a[index[0]])) {
          if (!isDesc[0]) {
            return a[index[0]] - b[index[0]];
          } else {
            return b[index[0]] - a[index[0]];
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      return items;
    },
    rowClass(item) {
      if (!item.resolved && item.chat) return "pink-background";
      else if (item.comms?.completed_am && item.comms?.completed_pm) return "blue-grey lighten-3";
      else if (item.comms?.completed_am || item.comms?.completed_pm) return "blue-grey lighten-4";
    },
    getId(base64string) {
      return decodeId(base64string);
    },
    applyFilters(data) {
      let hideAM = false;
      let hidePM = false;

      this.hideCompleted.selection.forEach((selection) => {
        switch (selection.name) {
          case "Hide AM":
            hideAM = true;
            break;
          case "Hide PM":
            hidePM = true;
            break;
        }
      });

      if (hideAM || hidePM) {
        data = data.filter((item) => {
          return (hideAM && !item.comms.completed_am) || (hidePM && !item.comms.completed_pm);
        });
      }

      if (this.hideResolved) {
        data = data.filter((item) => {
          return item.coachingChatId && !item.resolved;
        });
      }

      return data;
    },
    updateRows() {
      switch (this.hideCompleted.selection.length) {
        case 0:
          this.hideCompleted.selectionCheckbox = false;
          break;
        case 1:
          this.hideCompleted.selectionCheckbox = null;
          break;
        case 2:
          this.hideCompleted.selectionCheckbox = true;
          break;
      }
    },
    updateCheckbox(item, day_half = "Morning") {
      let is_am = day_half == "Morning";
      let input = {
        dayHalf: day_half,
        completed: is_am ? !item.comms.completed_am : !item.comms.completed_pm,
        coachId: this.$route.params.coachId,
      };

      if (item.program) {
        input["userProgramId"] = item.program.id;
      } else {
        input["subscriptionId"] = this.getId(item.id);
      }

      this.$apollo
        .mutate({
          mutation: SET_COMPLETED_QUERY,
          variables: input,
        })
        .catch(() => {
          this.emitProblem();
        });

      if (is_am) {
        item.comms.completed_am = !item.comms.completed_am;
      } else {
        item.comms.completed_pm = !item.comms.completed_pm;
      }
    },
    updateImpactCheckbox(item) {
      this.$apollo
        .mutate({
          mutation: SET_IMPACT_MUTATION,
          variables: {
            coachId: item.program.coach.id,
            clientId: item.program.user.id,
            didImpact: !item.coachImpact,
            impactDate: this.$moment().format("YYYY-MM-DD"),
          },
        })
        .catch((error) => {
          this.emitProblem();
        });
      item.coachImpact = !item.coachImpact;
    },
    reloadData() {
      this.$apollo.queries.coachDashboardListing?.refetch();
      this.$apollo.queries.userSubscriptions?.refetch();
      this.$apollo.queries.secondaryCoachingSubscriptions?.refetch();
      this.$apollo.queries.eligible?.refetch();
    },
    compactDate(value) {
      return this.$moment(value)?.format("ddd, DD MMM");
    },
    coveringText(sittingPeriod) {
      let text = "";

      if (sittingPeriod) {
        if (sittingPeriod.startDate && sittingPeriod.endDate) {
          text += `${this.compactDate(sittingPeriod.startDate)} - ${this.compactDate(sittingPeriod.endDate)} `;
        }
        text += `for ${getUserName(sittingPeriod.coach)}`;
      } else {
        text = "-";
      }

      return text;
    },
    emitProblem() {
      this.$emit("problem");
      this.problemConnecting = true;
    },
  },
  apollo: {
    coachDashboardListing: {
      query: COACHING_DASHBOARD_LISTING_QUERY,
      variables() {
        let input = {
          stages: this.stages,
          productType: this.productType,
          coachId: this.coachId,
          productProgramType: this.productProgramType,
        };
        if (this.packageCoachId) {
          input.packageCoachId = decodeId(this.packageCoachId);
        }

        return input;
      },
      fetchPolicy: "cache-and-network",
      skip() {
        return this.skipDashboardListingQuery;
      },
      result(response) {
        if (response.data && !response.loading) {
          this.subscriptions = response.data.coachDashboardListing.map((item) => {
            let nutritionPlan = item.user.userProfile.coachingNutritionPlan
              ? {
                  title: `${item.user.userProfile.coachingNutritionPlan.servingSize} ${item.user.userProfile.coachingNutritionPlan.dietaryRestriction}`,
                  pdf: item.user.userProfile.coachingNutritionPlan.pdf,
                }
              : {
                  title: item.nutritionPlan?.name,
                  pdf: item.nutritionPlan?.pdf,
                };

            let nextProductVariant = item.subscription.transitionProductVariant;

            return {
              id: item.subscription.id,
              userId: item.user.id,
              profile_pic: item.user.userProfile.profilePicture,
              profile_link: `/client-profile/${this.coachId}/${item.user.id}`,
              contact_link: `/clients/${item.user.id}`,
              client_name: `${item.user.firstName} ${item.user.lastName}`,
              nextSubscription: nextProductVariant
                ? `${nextProductVariant.product.title} ${nextProductVariant.billingPeriod}`
                : "None",
              upcomingPayment: item.upcomingPayment,
              username: item.user.email,
              client: item.user,
              dateOfBirth: item.user.userProfile?.dateOfBirth,
              signUpDate: this.$moment(item.subscription.startDate).format("YYYY-MM-DD"),
              lastCoachingAssessmentDate: item.user?.userProfile?.lastCoachingAssessmentDate,
              lastUserAssessmentDate: item.user?.userProfile?.lastUserAssessmentDate,
              subscriptionEndDate: item.subscription.endDate,
              subscriptionSurveyId: item.lastSubscriptionSurveyId,
              lastContact: item.user.userProfile?.coachingChat?.lastMessageTimestamp,
              nutritionPlan: nutritionPlan,
              nutritionBlock: item.nutritionBlock?.title ?? "No block selected",
              activeWorkoutBlocks: item.activeWorkoutBlocks,
              nextWorkoutBlocks: item.nextWorkoutBlocks,
              has_goal: item.hasBhag,
              has_checkin_goal: item.hasCheckinGoal,
              weeksOnProgram: item.weeksOnProgram,
              chat: item.user.userProfile.coachingChat,
              engagementScore: item.user.userProfile.engagementScore,
              coachingChatId: item.user.userProfile?.coachingChat?.id,
              lastMessage: item.user.userProfile.coachingChat?.lastMessage,
              resolved: item.user.userProfile.coachingChat?.resolved ?? false,
              comms: {
                completed_am: item.completedAm,
                completed_pm: item.completedPm,
                completed_weekly: !!item.coachActivity.find(
                  (x) =>
                    this.$moment(x.completedAt)
                      .startOf("isoWeek")
                      .format("YYYY-MM-DD") ===
                    this.$moment()
                      .startOf("isoWeek")
                      .format("YYYY-MM-DD")
                ),
              },
              stickyNote: item.stickyNote,
            };
          });

          this.chatsToMonitor = [];
          this.subscriptions.forEach((item) => {
            if (item?.chat?.id) this.chatsToMonitor.push(item.chat.id);
          });

          this.loading = false;
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
    },
    secondaryCoachingSubscriptions: {
      query: SECONDARY_COACHING_SUBSCRIPTION_QUERY,
      variables() {
        let input = {
          selectedDate: this.selectedDate,
        };
        if (this.secondaryCoachId) {
          input.secondaryCoachId = this.getId(this.secondaryCoachId);
        }
        return input;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          let coachSubscriptions = response.data.secondaryCoachingSubscriptions
            .map((item) => {
              var activeBlocks = item.subscription.user.subscriptionblockSet.filter((block) => {
                return this.$moment(block.startDate) <= this.$moment() && (this.$moment(block.endDate) >= this.$moment() || (!block.endDate && block.isSelfPaced));
              });
              let nutritionPlan = item.subscription.user.userProfile.coachingNutritionPlan
                ? {
                    title: `${item.subscription.user.userProfile.coachingNutritionPlan.servingSize} ${item.subscription.user.userProfile.coachingNutritionPlan.dietaryRestriction}`,
                    pdf: item.subscription.user.userProfile.coachingNutritionPlan.pdf,
                  }
                : {
                    title: item.subscription.user.userProfile.nutritionPlan?.name,
                    pdf: item.subscription.user.userProfile.nutritionPlan?.pdf,
                  };

              return {
                id: item.subscription.id,
                userId: item.subscription.user.id,
                profile_pic: item.subscription.user.userProfile.profilePicture,
                profile_link: `/client-profile/${this.coachId}/${item.subscription.user.id}`,
                contact_link: `/clients/${item.subscription.user.id}`,
                client_name: getUserName(item.subscription.user),
                billingDate: item.subscription?.billingOrder?.nextBillingDate,
                username: item.subscription.user.username,
                client: item.subscription.user,
                dateOfBirth: item.subscription.user.userProfile?.dateOfBirth,
                covering: this.coveringText(item.subscription.secondaryCoachSubscriptions?.edges[0]?.node?.period),
                signUpDate: this.$moment(item.subscription.startDate).format("YYYY-MM-DD"),
                programStartDate: item.subscription.programStartDate,
                lastCoachingAssessmentDate: item.user?.userProfile?.lastCoachingAssessmentDate,
                subscriptionEndDate: item.subscription.endDate,
                lastUserAssessmentDate: item.user?.userProfile?.lastUserAssessmentDate,
                nutritionPlan: nutritionPlan,
                nutritionBlock:
                  item.subscription.user.subscriptionnutritionblockSet.edges.length > 0
                    ? item.subscription.user.subscriptionnutritionblockSet.edges[0].node.nutritionBlock?.title
                    : "No block selected",
                activeWorkoutBlocks: activeBlocks,
                has_goal: item.subscription.hasBhag,
                has_checkin_goal: item.subscription.hasCheckinGoal,
                weeksOnProgram: item.subscription.weeksOnProgram,
                engagementScore: item.subscription.user.userProfile.engagementScore,
                lastMessage: item.subscription?.coachChat?.lastMessage,
                chat: item.subscription?.coachChat,
                resolved: item.subscription?.coachChat?.resolved ?? false,
                productType: item?.subscription?.product?.programType == "A_1_ON_1_WEEKLY" ? "Weekly" : "Daily",
                comms: {
                  completed_am:
                    item.subscription.coachactivitySet.edges.filter((val) => {
                      return val.node.dayHalf == "MORNING";
                    }).length > 0,
                  completed_pm:
                    item.subscription.coachactivitySet.edges.filter((val) => {
                      return val.node.dayHalf == "AFTERNOON";
                    }).length > 0,
                },
              };
            })
            .sort((a, b) => (a.weeksOnProgram < b.weeksOnProgram ? -1 : 1));

          //get unique users of combined arrays
          this.subscriptions = [
            ...new Map([...this.subscriptions, ...coachSubscriptions].map((item) => [item.id, item])).values(),
          ];
          this.loading = false;
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
      skip() {
        return !this.secondaryCoachId;
      },
    },
    messagesAfter: {
      query: MESSAGES_AFTER_QUERY,
      fetchPolicy: "no-cache",
      pollInterval: 60 * 1000,
      variables() {
        return {
          ago: 60, // time in seconds
          chats: this.chatsToMonitor,
        };
      },
      result(response) {
        if (response.data && !response.loading) {
          let messages = response.data.messagesAfter;
          messages.forEach((message) => {
            if (message.user.userProfile.userType !== "USER") return;
            //find the subscription
            let chatId = decodeId(message.chat.id);
            let subscription = this.subscriptions.find((element) => element.chat.id === chatId);
            subscription.lastMessage = message;
            subscription.resolved = message.chat.resolved;
            this.newMessagesFrom.push(message.user.firstName + " " + message.user.lastName);
          });
        }
      },
      skip() {
        return this.chatsToMonitor.length === 0;
      },
    },
  },
};
